import { Directive, ElementRef, Renderer2, OnDestroy, OnInit, Input } from '@angular/core';
import { LayoutService } from '@layout/services/layout.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[direction]'
})
export class DirectionDirective implements OnInit, OnDestroy {
  private dirSub!: Subscription;
  @Input() direction?:string;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.dirSub = this.layoutService.websiteDirection$.subscribe(direction => {
      const transform = (this.direction|| direction) === 'rtl' ? 'scaleX(-1)' : 'unset';
      this.renderer.setStyle(this.el.nativeElement, 'transform', transform);
    });
  }

  ngOnDestroy() {
    this.dirSub.unsubscribe();
  }
}
